import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=20a7f492&scoped=true&"
import script from "./ObjectInfo.vue?vue&type=script&lang=js&"
export * from "./ObjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7f492",
  null
  
)

export default component.exports